import type { JSX } from "preact";
import { useTheme, type ThemePref } from "../lib/theme";

const ORDER: ThemePref[] = ["light", "system", "dark"];
const LABEL: Record<ThemePref, string> = {
  light: "Svetlý",
  system: "Systém",
  dark: "Tmavý",
};

function Icon({ pref }: { pref: ThemePref }): JSX.Element {
  const common = {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": 1.75,
    "stroke-linecap": "round" as const,
    "stroke-linejoin": "round" as const,
    "aria-hidden": true,
  };
  if (pref === "light") {
    return (
      <svg {...common}>
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
      </svg>
    );
  }
  if (pref === "dark") {
    return (
      <svg {...common}>
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
      </svg>
    );
  }
  return (
    <svg {...common}>
      <rect x="3" y="4" width="18" height="13" rx="2" />
      <path d="M8 21h8M12 17v4" />
    </svg>
  );
}

export function ThemeSwitcher({ compact = false }: { compact?: boolean }) {
  const { pref, setPref } = useTheme();
  const next = ORDER[(ORDER.indexOf(pref) + 1) % ORDER.length]!;
  return (
    <button
      type="button"
      class={compact ? "theme-toggle theme-toggle--compact" : "theme-toggle"}
      aria-label={`Téma: ${LABEL[pref]}. Prepnúť na ${LABEL[next]}.`}
      title={`Téma: ${LABEL[pref]} (klikni pre ${LABEL[next]})`}
      onClick={() => setPref(next)}
    >
      <span class="theme-toggle__icon" aria-hidden="true">
        <Icon pref={pref} />
      </span>
      {!compact && <span class="theme-toggle__label">{LABEL[pref]}</span>}
    </button>
  );
}
